<template lang='pug'>
  .pa-2.pl-5.logs-editor.text-caption.font-weight-light.test-error(v-if='testOrTestRun.error')
    div {{testOrTestRun.error}}
    div(v-if='testOrTestRun.errorMeta').mt-2
      router-link(:to='link').text-body-2
        strong {{path}}&nbsp
        em {{line}}
</template>

<script>
export default {
  name: 'BionicMetricsError',
  props: {
    testOrTestRun: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundClass() {
      if (this.$vuetify.theme.dark) return 'dark';
      return 'red lighten-4';
    },
    path() {
      if (!this.testOrTestRun.errorMeta) return '';
      const {type, gitName, lineNumber} = this.testOrTestRun.errorMeta;
      return `${type}/${gitName}:${lineNumber}`;
    },
    line() {
      if (!this.testOrTestRun.errorMeta) return '';
      const {line} = this.testOrTestRun.errorMeta;
      if (!line) return '';
      return line.trim();
    },
    link() {
      if (!this.testOrTestRun.errorMeta) return '';
      const {type, guid, lineNumber} = this.testOrTestRun.errorMeta;
      return `/${type}/${guid}?line=${lineNumber}`;
    }
  }
};
</script>

<style scoped>
.test-error {
  border-radius: 4px;
  border-left: 5px solid #D84315;
  border-right: 1px solid #D84315;
  border-top: 1px solid #D84315;
  border-bottom: 1px solid #D84315;
}
</style>
